import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy · Buddha KA" },
      { name: "description", content: "How Buddha KA and KAfrequency use cookies and similar technologies." },
      { property: "og:title", content: "Cookie Policy · Buddha KA" },
      { property: "og:description", content: "Cookies used on buddhaka.com." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://buddhaka.com/cookies" },
      { property: "og:site_name", content: "Buddha KA · KAfrequency" },
    ],
    links: [{ rel: "canonical", href: "https://buddhaka.com/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Legal</p>
      <h1 className="mt-4 font-serif text-5xl">Cookie Policy</h1>
      <p className="mt-3 text-xs text-muted-foreground">Last updated: July 15, 2026</p>

      <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <p>This page explains the cookies and similar technologies used on buddhaka.com and what they do.</p>

        <h2 className="font-serif text-2xl text-foreground">Strictly necessary</h2>
        <p>Required to run the site: authentication sessions, cart state, checkout, and security. These cannot be turned off.</p>

        <h2 className="font-serif text-2xl text-foreground">Preferences</h2>
        <p>Remember your language, theme, and other display choices.</p>

        <h2 className="font-serif text-2xl text-foreground">Analytics</h2>
        <p>Help us understand which pages, releases, and products resonate. We use privacy-respecting analytics that do not track you across other sites.</p>

        <h2 className="font-serif text-2xl text-foreground">Marketing</h2>
        <p>Used by the Meta (Facebook) Pixel to measure the performance of ad campaigns, if we run them. You can opt out by declining marketing cookies in the banner shown on your first visit or by using your browser or device privacy controls.</p>

        <h2 className="font-serif text-2xl text-foreground">Managing cookies</h2>
        <p>You can accept or decline non-essential cookies from the banner shown on your first visit. You can reset your choice by clearing site data in your browser. Most browsers also let you block or delete cookies globally.</p>

        <h2 className="font-serif text-2xl text-foreground">Contact</h2>
        <p><a className="text-gold underline" href="mailto:support@buddhaka.com">support@buddhaka.com</a></p>
      </div>
    </div>
  );
}
